export default __webpack_public_path__ + "static/media/fross1.45f8049d.png";